/* eslint-disable no-constant-condition */
import { Box, Flex, Image, Stack, Text } from '@chakra-ui/react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useWindowSize } from 'src/hooks/useWindowSize'
import { useIamStore } from 'src/modules/iam/apis/store'

const LeftIllustration = () => {
  const { width, height } = useWindowSize()
  const [t] = useTranslation()
  const isMobile = useMemo(() => width && width < 600, [width])

  const { state } = useIamStore((store) => ({ state: store.state }))

  const conditionsToShowIllustrationImage = useMemo(() => {
    if (!isMobile) return true
    if (state('VERIFY_EMAIL') || state('CONFIRM_EMAIL_VERIFICATION')) return true
    if (height && height > 800) return true

    return false
  }, [isMobile, state, height])

  return (
    <Stack
      backgroundRepeat='no-repeat'
      flexDirection='column'
      alignItems='space-between'
      justify='flex-end'
      flex='0.7'
      pl={['20px', '38px', '52px', '52px', '52px']}
      pr={['20px', '38px', '52px', '52px', '52px']}
      pt={['28px', '28px', '55px', '76px', '76px']}
      pb={['10px', '10px', '0', '0', '0']}
    >
      <Flex flexDirection='column' align='flex-end' justifyContent='space-between' h='100%' flex={1}>
        <Box w='100%'>
          <Stack bg='secondaryColors.400' height='7px' width='54px' marginBottom='10px' />
          <Text
            color='white'
            fontSize={['23px', '23px', '32px', '32px', '32px']}
            fontWeight='500'
            lineHeight='35px'
            paddingRight={['0', '0', '0', '0', '35%']}
            letterSpacing='0.04em'
          >
            {t('login.platformSentence')}
            <br /> {t('login.platformSentence2')}{' '}
          </Text>
        </Box>
        {conditionsToShowIllustrationImage ? (
          <Image
            src='assets/images/dev_login.svg'
            position='relative'
            bottom='15%'
            left={['0', '0', '0', '0', '20%']}
            height='60%'
            w={{ base: '250px', sm: '320px', md: '400px', lg: '400px', xl: '100%' }}
            minWidth={{ base: '250px', '2xl': '539px' }}
            minHeight={{ base: '250px', '2xl': '348px' }}
          />
        ) : null}
      </Flex>
    </Stack>
  )
}

export default LeftIllustration
